import React from 'react';
import AnalysisPage from './AnalysisPage'

const AlertUtility = () => {
    const filters = [
        {
            name: "Utility",
            type: "dropdown",
            options: ["Electricity, Water, Natural Gas", "Heating Oil", "Propane"],
        },
        {
            name: "Demand",
            type: "button",
        },
        {
            name: "Consumption",
            type: "button",
        },
        {
            name: "Spend",
            type: "button",
        },
        {
            name: "Hourly",
            type: "date",
        },
        {
            name: "Start Date",
            type: "date",
        },
        {
            name: "End Date",
            type: "date",
        },
    ];

    return (
        <AnalysisPage title="Utility" filters={filters}></AnalysisPage>
    )
};

export default AlertUtility;
